// Dependency Type Mapping based on DMRC requirements
export const dependencyTypeMapping: Record<string, string> = {
  "": "Not Dependent",
  "N": "Not Dependent", 
  "M": "Medical and SWF only",
  "L": "LTC and SWF only", 
  "S": "SWF only",
  "X": "Complete dependency (Medical+LTC+SWF)",
  "R": "Only Medical (for retired and Spouse of Deceased Employee)"
};

/**
 * Get dependency type description from code
 * @param code - The dependency type code (M, L, S, X, R, N, null, or empty)
 * @returns The full description of the dependency type
 */
export const getDependencyTypeDescription = (code: string | null | undefined): string => {
  // Handle null, undefined, or empty string as "Not Dependent"
  if (code === null || code === undefined || code.toString().trim() === "") {
    return "Not Dependent";
  }
  
  const upperCode = code.toString().toUpperCase().trim();
  return dependencyTypeMapping[upperCode] || "Not Dependent";
};
